"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sandbox = {
    endpoints: {
        venues: process.env.REACT_APP_ENDPOINT_VENUES || 'https://sandbox-api.instacarro.com/sellers/v2/venues',
        auth: process.env.REACT_APP_ENDPOINT_AUTH || 'https://sandbox-api.instacarro.com/accounts',
        specifications: process.env.REACT_APP_ENDPOINT_SPECIFICATIONS || 'https://sandbox-api.instacarro.com/mechanics/specifications',
    },
};
exports.production = {
    endpoints: {
        venues: 'https://api.instacarro.com/sellers/v2/venues',
        auth: 'https://api.instacarro.com/accounts',
        specifications: 'https://api.instacarro.com/mechanics/specifications',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uZmlnL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQWEsUUFBQSxPQUFPLEdBQUc7SUFDckIsU0FBUyxFQUFFO1FBQ1QsTUFBTSxFQUFFLE9BQU8sQ0FBQyxHQUFHLENBQUMseUJBQXlCLElBQUksc0RBQXNEO1FBQ3ZHLElBQUksRUFBRSxPQUFPLENBQUMsR0FBRyxDQUFDLHVCQUF1QixJQUFJLDZDQUE2QztRQUMxRixjQUFjLEVBQUUsT0FBTyxDQUFDLEdBQUcsQ0FBQyxpQ0FBaUMsSUFBSSw2REFBNkQ7S0FDL0g7Q0FDRixDQUFDO0FBRVcsUUFBQSxVQUFVLEdBQUc7SUFDeEIsU0FBUyxFQUFFO1FBQ1QsTUFBTSxFQUFFLDhDQUE4QztRQUN0RCxJQUFJLEVBQUUscUNBQXFDO1FBQzNDLGNBQWMsRUFBRSxxREFBcUQ7S0FDdEU7Q0FDRixDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ../@core/dist/config/index.js
// module id = 878
// module chunks = 0